<FocusLoop :is-visible="isOpen">
<div class="ui-modal" :class="{'active':isOpen}">
  
  <div class="modal-all-block"
    :class="[styleClass, {'style--no-btn': !btnCancel.hasOwnProperty('text') && !btnConfirm.hasOwnProperty('text')}]">
    <div class="mask"></div>
    <div class="modal-block">
      <div class="title-block" v-if="title || subTitle">
        <div class="title-detail">
          <h3 class="title-main">{{title}}</h3>
          <h6 class="title-sub">{{subTitle}}</h6>
        </div>
        <a href="javascript:;" class="icon-block" v-if="isHasClose" @click="onClickCancel">
          <iCon class="icon-cancel" iconClass="asus_proart_sw_ico_cancel"></iCon>
        </a>
      </div>
      <div class="img-block" v-if="imgLink">
        <img :src="require(`@/assets/images/${imgLink}`)" alt="">
      </div>
      <div class="content-block">
        <template v-if="!content">
          <div class="content-detail">

          </div>
          <slot></slot>
        </template>
        <template v-else>
          <p class="text" v-html="content"></p>
        </template>
      </div>
      <div class="btm-block" v-if=" btnCancel.hasOwnProperty('text') || btnConfirm.hasOwnProperty('text')">
        
        <div class="btn-block">
          
          <Button v-if="btnCancel.hasOwnProperty('text') " class="btn-inline" :text="btnCancel.text"
            :theme="btnCancel.theme" :disable="btnCancel.disable" :colors="btnCancel.color" :type="btnCancel.type"
            :wd="btnCancel.wd" @onClick="clickCancel"></Button>
          <Button v-if="btnConfirm.hasOwnProperty('text') " class="btn-inline" :text="btnConfirm.text"
            :theme="btnConfirm.theme" :disable="btnConfirm.disable" :colors="btnConfirm.color" :type="btnConfirm.type"
            :wd="btnConfirm.wd" @onClick="clickConfirm"></Button>
            <div class="verifyFalse" v-if="isVerify">{{isVerify}}</div>
        </div>
      </div>
    </div>
  </div>
  
</div>
</FocusLoop>